import {
  arrayBuilderItemSubsequentPageTitleUI,
  textareaUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import {
  arrayOptions,
  createNewConditionName,
  disallowWhitespaceOnly,
} from './utils';
import { trackCauseCharLimit } from '../../../utils/tracking/features/causeCharLimitTracking';

const DEFAULT_HINT =
  'For example, "I operated loud machinery while in the service, and this caused me to lose my hearing."';

const defaultBuildTitle = conditionName =>
  `Briefly describe the injury, event, disease, or exposure that caused ${conditionName}.`;

/**
 * Builds the "cause of new condition" page.
 *
 * @param {Object} [options]
 * @param {string} [options.hint] - Override for the textarea hint
 * @param {(conditionName: string) => string} [options.buildTitle] - Builds the
 *   textarea title from the condition name.
 * @returns {PageSchema}
 */
export const createCauseNewPage = ({
  hint = DEFAULT_HINT,
  buildTitle = defaultBuildTitle,
} = {}) => {
  return {
    uiSchema: {
      ...arrayBuilderItemSubsequentPageTitleUI(
        ({ formData }) => createNewConditionName(formData, true),
        undefined,
        false,
      ),

      primaryDescription: {
        ...textareaUI({
          title: buildTitle('your condition'),
          hint,
          updateUiSchema: (_formData, fullData, index) => ({
            'ui:title': buildTitle(
              createNewConditionName(
                fullData?.[arrayOptions.arrayPath]?.[index],
              ),
            ),
          }),
          charcount: true,
        }),
        'ui:validations': [
          disallowWhitespaceOnly,
          // limit mirrors the schema maxLength below
          trackCauseCharLimit({
            field: 'primaryDescription',
            cause: 'NEW',
            limit: 900,
          }),
        ],
      },
    },

    schema: {
      type: 'object',
      properties: {
        primaryDescription: {
          type: 'string',
          minLength: 1,
          maxLength: 900,
        },
      },
      required: ['primaryDescription'],
    },
  };
};

// creates the causeNewPage with default options, used by v1 flow
const causeNewPage = createCauseNewPage();

export default causeNewPage;
